export const segments = {
  agencies: 'agencies',
  dispatching: 'dispatching',
};

export const routeParams = {
  agencyId: 'agencyId',
};

export const routes = {
  agencies: `/${segments.agencies}`,
  agency: (agencyId: string | number) => {
    return `${routes.agencies}/${agencyId}`;
  },
  dispatching: `/${segments.dispatching}`,
};
